const ChunkFilter = function(array, length) {

    let totalChunks = [];
    let chunkLength = parseInt(length, 10);

    if (chunkLength <= 0) {

        ("development") !== 'production' && _.warn(
            'The chunk filter requires an argument defining the chunk size.'
        );

        return array;
    }

    // Loop through the data and divide it into chunks
    for (let i = 0; i < array.length; i += chunkLength) {
        totalChunks.push(array.slice(i, i + chunkLength));
    }

    // Return the chunks of data
    return totalChunks;
}

export default ChunkFilter
